import {
  modifyOfferSyndicationConfig,
  receiveOfferSyndicationConfig,
  setOfferSyndicationConfigIsBusy,
  closeOfferSyndicationConfig,
  setOfferSyndicationConfigHasValidationError
} from './offer-syndication-config.actions';
import itemReducer from '../../../items/item.reducers';

const offerSyndicationConfigReducer = itemReducer(
  receiveOfferSyndicationConfig,
  setOfferSyndicationConfigIsBusy,
  modifyOfferSyndicationConfig,
  closeOfferSyndicationConfig,
  undefined,
  setOfferSyndicationConfigHasValidationError
);

export default offerSyndicationConfigReducer;
